/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(async function(algolia) {
  'use strict';
  const PLP_VIEW_KEY = 'LSKD_USER_PREF_PLP_VIEW';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  // var hits = algolia.externals.widgets.hits;
  // var menu = algolia.externals.widgets.menu;
  // var pagination = algolia.externals.widgets.pagination;
  var infiniteHits = algolia.externals.widgets.infiniteHits;
  var configure = algolia.externals.widgets.configure;
  var index_suffix = await algolia.config.index_suffix;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;

  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;

  var defaultQueryFilter = algolia.externals.custom.defaultQueryFilter;
  var collectionQueryFilter = algolia.externals.custom.collectionQueryFilter;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle =
      Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : collectionHandle;
  }

  function handleize(text) {
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if([
      'allow',
      'continue'
    ].includes(algolia.config.stock_policy)) {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
      stockPolicyFilter = collectionPageEnabled ? collectionQueryFilter : defaultQueryFilter;
    }
    else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    }
    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "reserved" by InstantSearch.
   * These parameters will be overwritten when the search state is written
   * to the URL.
   */
  var RESERVED_ALGOLIA_PARAMS = [
    'configure',
    'hierarchicalMenu',
    'menu',
    'range',
    'refinementList',
    'sortBy',
    'q',
    'query',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function(routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = Object.keys(routeState).reduce(function(acc, key) {
            if (RESERVED_ALGOLIA_PARAMS.indexOf(key) === -1) {
              acc[key] = routeState[key];
            }
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled &&
      algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: algolia.config.analytics_enabled,
      indexName: algolia.config.index_prefix + 'products' + index_suffix,
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products' + index_suffix),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPageEnabled) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders
  };

  instant.search.client.addAlgoliaAgent('Shopify Integration');

  algolia.instantsearch = instant;


  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }


  //Link CSS and set up CSS variables
  const cssFile = document.getElementById('template_algolia_instant_search.css');
  document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
  document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
  document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  algolia.appendStyle(cssFile.text);

  if (collectionPageEnabled) {
    if (
      document.querySelectorAll(algolia.config.collection_css_selector)
        .length === 0
    ) {
      throw new Error(
        'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
      );
    }
  } else if (
    document.querySelectorAll(algolia.config.results_selector).length === 0
  ) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  // Instantiating the main page
  instant.$results = document.querySelector(instant.selector);
  instant.$results.innerHTML = '';

  algolia.render(algolia.instantSearchMainTemplate, instant.$results, {
    facets: instant.facets.list,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function() {
    readjust();
  });

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      facetingAfterDistinct: false,
    }),
  ]);

  const path = window.location.pathname;
  const lastPathSegment = path.split('/').pop();
  const { algoliaExcludeCollectionsToIgnore } = theme.settings;
  if (path === '/search' || algoliaExcludeCollectionsToIgnore.includes(lastPathSegment)) {
    // Search input
    instant.search.addWidgets([
      searchBox({
        container: '.ais-search-box-container',
        placeholder: path === '/search' ? algolia.translations.searchForProduct : 'Search Warehouse Sale',
        showReset: true,
        showSubmit: true,
        cssClasses: {
          root: 'tw-h-full',
          input: [
            'aa-Input',
            'tw-m'
          ],
          form: [
            'tw-flex',
            'tw-mt-0',
            'aa-Form',
          ],
          submit: 'tw-order-first',
          resetIcon: [
            'tw-w-4',
            'tw-h-4',
          ],
        }
      }),
    ]);
  }


  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text(data, {html}){
          return algolia.instantSearchStatsTemplate(data, html)
        }
      }
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
      }),
    ]);
  }

  // Change display
  instant.search.addWidgets([
    {
      init: function() {
        const currentDisplay = localStorage.getItem(PLP_VIEW_KEY) || 'list'

        const displayBlockBtn = document
          .querySelector('.ais-search-header .ais-change-display-block')

        const displayListBtn = document
          .querySelector('.ais-search-header .ais-change-display-list')

        displayBlockBtn?.addEventListener('click', function() {
          localStorage.setItem(PLP_VIEW_KEY, 'block')

          document
            .querySelector(
              '.ais-change-display-block:not(.ais-change-display-selected)'
            )
            .classList.add('ais-change-display-selected');
          document
            .querySelector(
              '.ais-change-display-list.ais-change-display-selected'
            )
            .classList.remove('ais-change-display-selected');
          document
            .querySelector('.ais-results-as-list')
            .classList.replace('ais-results-as-list', 'ais-results-as-block');

          document.dispatchEvent(new Event('initDropTimer'));
        });

        displayListBtn?.addEventListener('click', function() {
          localStorage.setItem(PLP_VIEW_KEY, 'list')

          document
            .querySelector(
              '.ais-change-display-list:not(.ais-change-display-selected)'
            )
            .classList.add('ais-change-display-selected');
          document
            .querySelector(
              '.ais-change-display-block.ais-change-display-selected'
            )
            .classList.remove('ais-change-display-selected');
          document
            .querySelector('.ais-results-as-block')
            .classList.replace('ais-results-as-block', 'ais-results-as-list');

          document.dispatchEvent(new Event('initDropTimer'));
        });

        if (window.innerWidth < 1024) {
          (currentDisplay === 'block' ? displayBlockBtn : displayListBtn)?.click()
        }
      },
    },
  ]);

  const productCache = {};
  const styleCache = {};

  instant.search.on('render', function () {
    function imgURL(src, size) {
      return src
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
          return '_'+size+match;
        });
    }

    const productHits = document.querySelectorAll('.ais-Hits-item');

    if (productHits.length > 0) {
      document.dispatchEvent(new Event('initDropTimer'));
      document.dispatchEvent(new Event('renderTagContent'));
    }

    const observer = new IntersectionObserver(async (entries, observer) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const childElement = entry.target.querySelector('.ais-product');
          const colourwayContainer = entry.target.querySelector('.plp-colhandle');
          const styleHandle = childElement.getAttribute('data-style-handle');
          const currentProductHandle = childElement.getAttribute('data-handle');
          const isOgProduct = childElement.getAttribute('data-og-product') === 'true';

          function swatchSort(a, b) {
            // if the swatch is the same product of the current card product, move to the front
            return a.handle === currentProductHandle ? -1 : b.handle === currentProductHandle ? 1 : 0;
          }

          try {
            let sameStyleProducts = styleCache[styleHandle];
            if (!sameStyleProducts) {
              sameStyleProducts = await ShopifyStoreFrontAPI.getSameStyleProducts(styleHandle, isOgProduct);
              if (sameStyleProducts.length > 0) {
                styleCache[styleHandle] = sameStyleProducts;
              }
            }
            let itemCount = 0;
            let colourwayHtml = '<div class="plp-colhandle__list">';

            sameStyleProducts
              .sort(swatchSort)
              .forEach(function (product) {
                const swatchUrl = product.handle;
                const swatchFeaturedImage = product.featuredImage;
                const swatchPrice = product.price;
                const swatchComparePrice = product.compareAtPrice;

                if (product.swatchColor) {
                  const isCurrentProduct = swatchUrl === currentProductHandle;
                  const activeClass = isCurrentProduct ? 'active' : '';

                  itemCount++;
                  colourwayHtml += `
                    <div class="plp-colhandle__list-item ${activeClass}">
                      <a href="/products/${swatchUrl}"
                        title="${product.colourNamePrint}"
                        data-product-title="${encodeURIComponent(algolia.helpers.fullTitle(product.title))}"
                        data-swatch-handle="${swatchUrl}"
                        data-swatch-title="${product.colourNamePrint}"
                        data-swatch-img="${swatchFeaturedImage}"
                        data-swatch-price="${swatchPrice}"
                        data-swatch-compare="${swatchComparePrice}"
                        class="plp-colhandle__list-item-link">
                        <span style="background:${product.swatchColor}"></span>
                      </a>
                    </div>
                  `;
                }
              });
            colourwayHtml += '</div>';

            colourwayContainer.innerHTML = colourwayHtml;
            addSwatchEventHandler(entry.target);
          } catch (error) {
            console.error('Error fetching data:', error);
          }
          observer.unobserve(entry.target);
        }
      }
    });

    // Start Observing
    productHits.forEach(element => {
      if (element.firstElementChild.getAttribute('data-static-tile')){
        return;
      }

      observer.observe(element);
    });

    // Check device
    const isTouchEnabled = ('ontouchstart' in window);

    // Build Quick add html + secondary image
    async function buildQuickAdd($productHit) {
      const handle = $productHit.attr('data-handle');
      const $imgWrapper = $productHit.find('.ais-hit--picture_wrapper');
      const prevHandle = $imgWrapper.data('handle')

      if(handle === prevHandle){
        return;
      }

      $imgWrapper.data('handle', handle)

      if (!productCache[handle]) {
        const data = await ShopifyStoreFrontAPI.fetchProductByHandle(handle)
        if(!data){
          return;
        }
        productCache[handle] = data
      }

      const product = productCache[handle];

      const $quickAdd = $productHit.find('.quick-add');
      const $countdown = $productHit.find('.plp-countdown');
      const $quickAddBtn = $productHit.find('.btn-quickadd');

      const dropDateTime = algolia.helpers.parseSqlDate(product.dropDateTime);
      const hasValidDropIn = dropDateTime && dropDateTime > new Date();

      const targetImages = (isTouchEnabled ? product.images : product.images?.slice(0, 2)) ?? [];
      const mobileImageSize = (localStorage.getItem(PLP_VIEW_KEY) || 'list') === 'list' ? '50vw' : '100vw';
      const imageHTML = targetImages.reduce((html, image, index) => `
            ${html}
            <div class="ais-hit--picture_item ${index === 0 ? "ais-hit--picture_main" : "ais-hit--picture_second"}">
              <img
                src="${image}"
                srcset="${image}&width=240 240w,
                        ${image}&width=480 480w,
                        ${image}&width=720 720w,
                        ${image}&width=960 960w,
                        ${image}&width=1440 1440w,
                        ${image}&width=1920 1920w"
                sizes="(min-width: 1280px) 25vw, (min-width: 1024px) 50vw, ${mobileImageSize}"
                loading="${index === 0 ? "eager" : "lazy"}"
                alt="${product.title}"
                width="800"
                height="1000"
              />
            </div>`
      , '');

      $imgWrapper.empty().append(imageHTML);

      let quickAddHtml = '<ul class="quick-add_item tw-flex tw-flex-wrap tw-justify-center tw-gap-x-4 tw-gap-y-3 tw-px-5 tw-py-4 md:tw-py-[30px]">';
      $.each(productCache[handle].variants, function(i, item){
        var variantID = item.id, variantTitle = item.title, variantAvailable = item.available;
        var varTitle = variantTitle.split(' / ').pop();
        quickAddHtml += `
        <li><span class='quick-add_item
        btn-xl
        tw-flex
        tw-rounded-full
        tw-p-0
        tw-size-[30px]
        md:tw-size-10
        tw-text-[9px]
        md:tw-text-[11px]
        tw-leading-none
        tw-cursor-pointer
        [&_>span]:tw-m-auto
        ' data-varid='${variantID}' data-varavail='${variantAvailable}'><span>${varTitle}</span></span></li>`;
      });
      quickAddHtml += '</ul>';
      const canDisableQuickAdd = algolia.helpers.tagQuickAddAvailable(product.tags) === 'disabled' || !!hasValidDropIn || !product.available || !!product.pinCode;
      $quickAdd.html(quickAddHtml).toggleClass('disabled', canDisableQuickAdd);
      $quickAddBtn.toggleClass('disabled', canDisableQuickAdd);

      // Rebuild Countdown
      if (hasValidDropIn) {
        $countdown.html(`
          <div
            data-component="DropTimer"
            data-props='{
              "date": "${product.dropDateTime}",
              "title": "Drops In"
            }'
          ></div>
        `)
        document.dispatchEvent(new Event('initDropTimer'));
      } else {
        $countdown.html('')
      }

      // Rebuild Badges
      $productHit.find('div[data-component="TagContent"]').get().forEach((el) => {
        el.dataset.props = JSON.stringify({
          productId: product.id,
          tags: product.tags,
          section: el.dataset.section,
        })
      });
      document.dispatchEvent(new Event('renderTagContent'));
    }

    // Product Item Swatches
    function addSwatchEventHandler(el) {
      const $productHit = $(el).find('.ais-product');
      const $swatchItems = $productHit.find('.plp-colhandle__list-item');
      const $swatches = $productHit.find('.plp-colhandle__list-item-link');

      // List of DOM elements to be updated
      const $activeColourTitle = $productHit.find('.ais-hit--details_grid-title-variant');
      const $activeMainImage = $productHit.find('.ais-hit--picture_main img');
      const $activeMainPrice = $productHit.find('.ais-hit--price-main');
      const $activeStrikePrice = $productHit.find('.ais-hit--price-striked');
      const $activeHitLink = $productHit.find('.ais-hit--picture > a, .ais-hit--title > a');
      const $activeProductTitle = $productHit.find('.ais-hit--title > a');

      $swatches.on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        isTouchEnabled && $productHit.find('.ais-hit--picture_wrapper').animate({ scrollLeft: 0 }, 250);

        // Extract known data from the swatch element. Extra data will come from the product.js fetch
        const $this = $(this);
        const swatchHandle = $this.attr('data-swatch-handle');
        const swatchTitle = $this.attr('data-swatch-title');
        const swatchPrice = $this.attr('data-swatch-price');
        const swatchComparePrice = $this.attr('data-swatch-compare');
        const swatchFeaturedImage = $this.attr('data-swatch-img');
        const productTitle = decodeURIComponent($this.attr('data-product-title'));

        // Update active product's handle for quick add fetch
        $productHit.attr('data-handle', swatchHandle);

        // Toggle 'active' class
        $swatchItems.removeClass('active');
        $this.parent().addClass('active');

        // Update product card
        $activeColourTitle.html(`<span>${swatchTitle}</span>`);
        $activeMainImage.attr('src', imgURL(swatchFeaturedImage, 'grande'));
        $activeHitLink.attr('href', `/products/${swatchHandle}`);
        $activeMainPrice.html(`<span>${algolia.helpers.displayPrice({ price: swatchPrice }) }</span>`);
        $activeProductTitle.html(productTitle);

        const strikePrice = algolia.helpers.displayStrikedPrice(swatchPrice, swatchComparePrice, swatchPrice.currency);

        $activeStrikePrice.html(strikePrice ? `
          <span>
            ${strikePrice}
            <span class="tw-inline md:tw-hidden">${Shopify?.currency?.active}</span>
          </span>` : ''
        );
        buildQuickAdd($productHit);
      })
    }

    $('.ais-facets_wrapper .ais-facet-dropdown-wrapper input[type="checkbox"]').prop('checked', true);
    $('.ais-facets_wrapper .ais-facet-dropdown-wrapper:first-child input[type="checkbox"]').prop('checked', false);

    $('.ais-Hits-item').each(function(){
      const $this = $(this);
      var quickAddWrapper = $this.find('.quick-add_container');
      var quickAddBtn = $this.find('.btn-quickadd');

      $(window).mouseup(function (e) {
        if (!quickAddBtn.is(e.target) && quickAddBtn.has(e.target).length === 0) {
          quickAddWrapper.toggleClass('tw-hidden', true);
        } else {
          quickAddWrapper.toggleClass('tw-hidden', false);
        }
      });

      quickAddBtn.on('click', function(){
        quickAddWrapper.removeClass('tw-hidden');
      })
      $this.find('.ais-hit--picture').on('mouseenter touchmove', function(event){
        if ($this.find('[data-static-tile]').length > 0) {
          return;
        }
        buildQuickAdd($this.find('.ais-product'));
      });
    });


    //Mobile Active Filter
    var countAct = $('.ais-current-refined-values--item').length;
    $('.js-drawer-open-drawer-filter .filter_buble').text(countAct).attr('data-filcount', countAct);
    $('.btn-applyfilter_count').text(' ('+countAct+')').attr('data-filcount', countAct);

    $('.js-drawer-open-drawer-filter').on('click',function(){
      var drawerID = $(this).attr('aria-controls');
      $('body').addClass('js-drawer-open');
      $('#'+drawerID).addClass('drawer--is-open');
      $('#'+drawerID).find('.js-drawer-close').on('click', function(){
        $('body').removeClass('js-drawer-open');
        $('#'+drawerID).removeClass('drawer--is-open');
      });
      $('#'+drawerID).find('.btn-applyfilter').on('click', function(){
        $('body').removeClass('js-drawer-open');
        $('#'+drawerID).removeClass('drawer--is-open');
      });

      const drawer = document.getElementById(drawerID)

      if (drawer) {
        drawer.querySelectorAll('details:has([class*=\'-item--selected\']), details#price')
          .forEach(details => details.setAttribute('open', 'true'))

        // SORT SECTION
        const select = drawer.querySelector(".ais-sort select");
        const list = drawer.querySelector("ul.sort-list-items");

        list.innerHTML = "";

        Array.from(select.options).forEach((option) => {
          const li = document.createElement("li");
          li.innerHTML = `
            <div class="tw-flex tw-items-center">
              <svg class="tw-size-[24px] tw-mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="black" fill="none"/>
                <polyline class="tw-hidden"
                points="6 12 10 16 18 8" stroke="black" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="tw-text-[14px]">${option.textContent}</span>
            </div>
          `;
          li.className = "ais-HierarchicalMenu-item tw-cursor-pointer tw-py-1";

          if (select.value === option.value) {
            li.classList.add("ais-HierarchicalMenu-item--selected", "active", "[&.active_polyline]:tw-block");
          }

          li.addEventListener("click", () => {
            select.value = option.value;
            document.querySelectorAll(".ais-HierarchicalMenu-item").forEach((el) =>
              el.classList.remove("ais-HierarchicalMenu-item--selected", "[&.active_polyline]:tw-block"));
            li.classList.add("ais-HierarchicalMenu-item--selected", "active", "[&.active_polyline]:tw-block");

            select.dispatchEvent(new Event("change"));
          });

          list.appendChild(li);
        });
      }
    })

    var filterDr = $('.drawer-filter');
    $(window).mouseup(function(e) {
      if (!filterDr.is(e.target) && filterDr.has(e.target).length === 0) {
        $('body').removeClass('js-drawer-open');
        filterDr.removeClass('drawer--is-open');
      }
    });

    $(window).on('resize load', function() {
      if ($(window).width() < 799){
        $('#DrawerFilter .drawer-filter__inner').addClass('drawer__inner');
        $('#DrawerFilter .drawer-filter__inner .ais-facets').show();

        setTimeout(function () {
          $('.js-drawer-open-drawer-filter').css('visibility','visible');
        }, 100);

        var results = $('.ais-stats--nb-results').text();
        $('.mob-stats').text("("+results+")");

      }else{
        $('#DrawerFilter').removeClass('drawer drawer--left');
        $('#DrawerFilter .drawer-filter__inner').removeClass('drawer__inner');
      }
    });

    function colorFacets() {
      $('.ais-facet-named_tagscolour .ais-facet--label').each(function() {
        const $this = $(this);
        const [swatchName, primaryColour, ...secondaryColours] = $this.data('originalLabel').split('|');

        $this.text(swatchName);

        if (primaryColour) {
          if (primaryColour.startsWith('#')) {
            const gradientStops = [primaryColour, ...secondaryColours].reverse().map(function(colour, index) {
              return `${colour} 0 ${((index + 1) * (100 / (secondaryColours.length + 1)))}%`;
            }).join(', ');
            $this.css('--background', `conic-gradient(${gradientStops})`);
          } else if (primaryColour.includes('.jpg')) {
            const image = theme.settings.assetURL.replace('colorplaceholder.jpg', primaryColour);
            $this.css('--background', `url(${image}) no-repeat center center / cover`);
          }
        }else{
          $this.css('--background', swatchName);
        }
      });
    }

    colorFacets();

    $('.ais-facet-named_tagscolour .ais-RefinementList-showMore').on('click', function(){
      colorFacets();
    });
  })

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // Create the render function
  var createDataAttributes = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function(refinement) {
        let label = refinement.label;
        if (label.includes('|')) {
          label = label.split('|')[0].trim();
        }
        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a ' +
          createDataAttributes(refinement) +
          '    class="ais-current-refined-values--link hover:tw-no-underline tw-group">' +
          '    <div class="tw-flex tw-items-center tw-bg-gray-200 group-hover:tw-bg-[#CCC] tw-text-[14px] tw-rounded-[20px] tw-p-1 tw-pl-3 tw-pr-2">' +
          '      <div class="ais-current-refined-values--label hide">' +
          facet.title +
          '      </div><span class="group-hover:tw-line-through">' +
          label +
          '   </span><span class="tw-block tw-text-[18px] tw-pl-4"><svg viewBox="0 0 20 20" width="6" height="6" aria-hidden="true"><path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"></path></svg></span></div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    const header = document.querySelector('.ais-current-refined-values-container-header')

    const containers = [header, widgetParams.container]

    containers.forEach(container => {
      if (!container) return;
      container.innerHTML =
      '<div class="ais-current-refined-values--header ais-facet--header ais-header hide">Selected filters</div>' +
      '<div class="ais-root ais-current-refined-values ais-facet tw-pl-8 tw-p-0">' +
      '  <ul class="ais-current-refined-values--list tw-gap-3">' +
        items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

      Array.prototype.slice
        .call(
          container.querySelectorAll(
            '.ais-current-refined-values--link'
          )
        )
        .forEach(function (element) {
          element.addEventListener('click', function (event) {
            var item = Object.keys(event.currentTarget.dataset).reduce(function (
              acc,
              key
            ) {
              var itemData = {};
              itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
              return algolia.assign({}, acc, itemData);
            },
              {});

            refine(item);
          });
        })
    })
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function(resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function(facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function(widget) {
    var facetWithPanel = panel({
      hidden: function(options) {
        const facetValuesH = options.results.getFacetValues(widget.params.attribute);
        var hidebelow1 = Array.isArray(facetValuesH) ? facetValuesH.length <= 1 : false;

        //var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hidebelow1 ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = '.ais-facet-' + handleize(widget.params.attribute);
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hidebelow1;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });

  //const sessionStorageCache = instantsearch.createInfiniteHitsSessionStorageCache();
  // Hits
  instant.search.addWidgets([
    infiniteHits({
      container: '.ais-hits-container',
      showPrevious: true,
      templates: {
        item(hit, {html, components}) {
          return algolia.instantSearchProductTemplate(hit, html, components);
        },
        empty(results, {html}) {
          return algolia.instantSearchNoResultTemplate(html);
        },
        showMoreText(data, { html }) {
          return html`<span>Load more</span>`;
        },
        showPreviousText(data, { html }) {
          return html`<span>Load previous</span>`;
        }
      },
      transformItems: function(items) {
        return items.map( item => ({
          ...item,
          _distinct: instant.distinct,
          can_order:
            item.inventory_management !== 'shopify' ||
            item.inventory_policy === 'continue' ||
            item.inventory_quantity > 0,
          queryID: item.__queryID,
          productPosition: item.__position,
          index: instant.search.mainIndex.getIndexName()
        }));
      },
      // cache: sessionStorageCache,
      cssClasses: {
        root: 'ais-Hits',
        list: 'ais-Hits-list',
        item: 'ais-Hits-item',
        loadMore: 'btn-loadmore btn',
        loadPrevious:'btn-previous btn'
      }
    })
  ]);





  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var redir;
          var hit;
          do {
            if (el.matches('.ais-hit a')) {
              hit = el;
              redir = true;
              break;
            }else if(el.matches('.quick-add_container')){
              redir = false;
              break;
            }else if(el.matches('.btn-quickadd')){
              redir = false;
              break;
            }else if(el.matches('.plp-colhandle__list-item-link')){
              redir = false;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;

          // Construct the link we should redirect to
          var link = `${window.Shopify.routes.root}products/${productHandle}`;

          if (algolia.config.analytics_enabled) {
            const clickData = {
              index: hit.dataset.algoliaIndex,
              eventName: 'click',
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
            };

            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
            algolia.saveForConversionTracking(clickData);
          }

          if(redir){
            window.location.href = link;
          }else{
            e.stopPropagation();
            e.preventDefault();
          }

        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var cartButton;
          do {
            if (el.matches('.ais-hit--cart-button')) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) {
            return;
          }

          e.stopPropagation();
          var $this = cartButton;
          var formId = $this.dataset.formId;

          if (formId) {
            document.getElementById(formId).submit();
          }
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  // Add Progress Bar to the bottom of the page using the InfiniteHits Connector as it has the current hits data.
  const progressBar = instantsearch.connectors.connectInfiniteHits(function(renderOptions, isFirstRender) {
    const {hits, results, widgetParams} = renderOptions;
    const actual = Number(hits.length) || 0;
    const total = Number(results && results.nbHits) || 0;

    widgetParams.container.innerHTML = actual > 0 ? `
      <div class="ais-stats-content">
        Showing <strong>${actual}</strong> of <strong>${total}</strong> results
      </div>
      <progress id="result-progressbar" value="${actual}" max="${total}"></progress>
    ` : '';
  });

  instant.search.addWidgets([
    progressBar({
      container: document.querySelector('.ais-progress-container')
    })
  ]);

  instant.search.start();

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);
